import React, { useEffect, useState } from 'react';
import { Box, Container, makeStyles, Typography } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import Page from 'src/app/components/Page';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetImages,
  AdminGetImages,
  resetListImg,
  GetImagesByUserId
} from '../../../../features/imageSlice';
import LoadingComponent from '../../../components/Loading';
import ImageDetail from './ImageDetail';
import HeaderToolBar from './HeaderToolBar';
import { roles } from '../../../constant/roles';
import Result from './Result';
import { _convertObjectToQuery } from 'src/app/utils/apiService';
import moment from 'moment';
import { getVehicleLicensePlateCamera } from 'src/features/vehicleSlice';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingLeft: props => (props.isSidebarOpen ? '384px' : '28px'),
    transition: 'padding-left 0.3s ease'
  },
  productCard: {
    height: '100%'
  },
  errorMessage: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#D9042F',
    textAlign: 'center',
    justifyContent: 'cemter'
  },
  loadingWrapper: {
    position: 'fixed',
    top: 0,
    left: props => (props.isSidebarOpen ? '384px' : '0'),
    width: props => (props.isSidebarOpen ? 'calc(100vw - 384px)' : '100vw'),
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const ImageList = () => {
  const query = useQuery();
  const name = query.get('license_plate');
  const start_date = query.get('start_date');
  const end_date = query.get('end_date');

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const classes = useStyles({ isSidebarOpen });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const roleUser = dataLogin && dataLogin.role?.title;
  const agencyId = dataLogin && dataLogin.agency?.id;
  const userID = dataLogin?.endUser ? dataLogin.endUser.id : undefined;
  const isLoading = useSelector(state => state.imageSlice.isLoading);
  const listImages = useSelector(state => state.imageSlice.listImage);

  const [isShowModalImgDetails, setShowModalImg] = React.useState(false);
  const [isShowResult, setShowResult] = React.useState(false);
  const [sendData, setSendData] = React.useState(undefined);

  const isAdmin =  useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isEndUser =
    dataLogin && dataLogin.role && dataLogin.role.title === roles.ENDUSER;

  useEffect(() => {
    if (isAgency) {
      dispatch(getVehicleLicensePlateCamera(`/${agencyId}`));
    }else{
      dispatch(getVehicleLicensePlateCamera(''));
    }
  }, [isAdmin, isAgency, isEndUser, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetListImg());
    };
  }, [dispatch]);

  const [params, setParams] = useState({
    license_plate: name || '',
    start_date:
      Math.floor(
        moment(start_date)
          .utcOffset(0)
          .unix()
      ) ||
      moment()
        .subtract(7, 'd')
        .utcOffset(0)
        .unix() ||
      '',
    end_date:
      Math.floor(
        moment(end_date)
          .utcOffset(0)
          .unix()
      ) ||
      moment()
        .subtract(7, 'd')
        .utcOffset(0)
        .unix() ||
      ''
  });

  const getListImageWithParams = data => {
    const paramValue = Object.assign({}, params, data);
    const dataFormatUix = {
      license_plate: data.license_plate,
      start_date:
        Math.floor(
          moment(data.start_date)
            .utcOffset(0)
            .unix()
        ) ||
        moment()
          .subtract(7, 'd')
          .utcOffset(0)
          .unix(),
      end_date:
        Math.floor(
          moment(data.end_date)
            .utcOffset(0)
            .unix()
        ) ||
        moment()
          .subtract(7, 'd')
          .utcOffset(0)
          .unix()
    };

    setParams(paramValue);
    navigate(`/app/image?${_convertObjectToQuery(paramValue)}`);
    const paramFormattedValue = Object.assign({}, paramValue, dataFormatUix);

    if (isAdmin) {
      dispatch(AdminGetImages(paramFormattedValue));
    } else if (isAgency) {
      dispatch(GetImages({ payload: paramFormattedValue, agencyId: agencyId }));
    } else if (isEndUser) {
      dispatch(GetImagesByUserId({ id: userID, data: paramFormattedValue }));
    }
  };

  const clearSearch = () => {
    const paramValue = {
      license_plate: ''
    };
    setParams(paramValue);
    if (roleUser && roleUser === roles.ADMIN) {
      dispatch(AdminGetImages(paramValue));
    } else {
      dispatch(GetImages({ payload: paramValue, agencyId }));
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Page className={classes.root}>
      <HeaderToolBar
        querySearch={{
          name: name,
          start_date: start_date,
          end_date: end_date
        }}
        isLoading={isLoading}
        searchRef={getListImageWithParams}
        clearSearchRef={clearSearch}
        setShowResult={setShowResult}
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
      />
      <Container maxWidth={false}>
        <Box mt={3}>
          {isLoading ? (
            <div className={classes.loadingWrapper}>
              <LoadingComponent />
            </div>
          ) : (
            <Result isShowResult={isShowResult} isSidebarOpen={isSidebarOpen} />
          )}
          {isShowResult === false && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="60vh"
            >
              <Typography className={classes.errorMessage}>
                Vui lòng chọn biển số hoặc tên để tìm kiếm ảnh
              </Typography>
            </Box>
          )}
        </Box>
      </Container>
      {isShowModalImgDetails && sendData && (
        <ImageDetail
          open={isShowModalImgDetails}
          data={sendData}
          closeRef={() => setShowModalImg(false)}
        />
      )}
    </Page>
  );
};

export default ImageList;
